import { get } from 'lodash';
import { RequestValidationTypes } from '../enums/requestValidationTypes';
import { ServiceCode } from '../enums/serviceCode';
import { ServiceType } from '../enums/serviceType';

const requestValidationTypes = {
    [ServiceCode.TPC]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tpcV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tpcV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tpcV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tpcV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TPO]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tpoV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tpoV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tpoV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tpoV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.PILOT]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.pilotExaminationV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotExaminationV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.pilotExaminationV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotExaminationV1EditFinalRequest,
                },
            },
        },
        [ServiceType.referral]: {
            add: {
                draft: {
                    1: RequestValidationTypes.pilotReferralV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotReferralV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.pilotReferralV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotReferralV1EditFinalRequest,
                },
            },
        },
        [ServiceType.referralSmall]: {
            add: {
                draft: {
                    1: RequestValidationTypes.pilotReferralSmallV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotReferralSmallV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.pilotReferralSmallV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotReferralSmallV1EditFinalRequest,
                },
            },
        },
        [ServiceType.contact]: {
            add: {
                draft: {
                    1: RequestValidationTypes.pilotContactV1AddRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotContactV1AddRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.pilotContactV1EditRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotContactV1EditRequest,
                },
            },
        },
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.pilotConsultationV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotConsultationV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.pilotConsultationV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.pilotConsultationV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TCOR]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tcorV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcorV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tcorV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcorV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TIECG]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tiecgV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tiecgV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tiecgV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tiecgV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TCCr]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tccrV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tccrV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tccrV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tccrV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TCCh]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tcchV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcchV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tcchV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcchV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TCCi]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tcciV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcciV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tcciV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcciV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OSASV]: {
        [ServiceType.referralSmall]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osasvV1AddDraftReferralSmall,
                },
                final: {
                    1: RequestValidationTypes.osasvV1AddFinalReferralSmall,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osasvV1EditDraftReferralSmall,
                },
                final: {
                    1: RequestValidationTypes.osasvV1EditFinalReferralSmall,
                },
            },
        },
    },
    [ServiceCode.OSASO]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osasoV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasoV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osasoV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasoV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OSASVO]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osasvoV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasvoV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osasvoV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasvoV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OSASQ]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osasqV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasqV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osasqV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasqV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OSASVC]: {
        [ServiceType.contact]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osasvcV1AddDraftRequest,
                    2: RequestValidationTypes.osasvcV2AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasvcV1AddFinalRequest,
                    2: RequestValidationTypes.osasvcV2AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osasvcV1EditDraftRequest,
                    2: RequestValidationTypes.osasvcV2EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasvcV1EditFinalRequest,
                    2: RequestValidationTypes.osasvcV2EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZCg]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzcgV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzcgV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzcgV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzcgV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZCf2f]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzcf2fV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzcf2fV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzcf2fV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzcf2fV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZCt]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzctV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzctV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzctV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzctV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZCtriage]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzctriageV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzctriageV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzctriageV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzctriageV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZCmdo]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzcmdoV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzcmdoV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzcmdoV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzcmdoV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZv]: {
        [ServiceType.referral]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzvV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzvV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzvV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzvV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZOint]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzoIntV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzoIntV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzoIntV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzoIntV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZOembl]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzoEmblV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzoEmblV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzoEmblV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzoEmblV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GGZBther]: {
        [ServiceType.counseling]: {
            add: {
                draft: {
                    1: RequestValidationTypes.ggzbTherV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzbTherV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.ggzbTherV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.ggzbTherV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GTO]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.gtoV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.gtoV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.gtoV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.gtoV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TFO]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tfoV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tfoV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tfoV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tfoV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TCOH]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tcohV1AddDraftRequest,
                    2: RequestValidationTypes.tcohV2AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcohV1AddFinalRequest,
                    2: RequestValidationTypes.tcohV2AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tcohV1EditDraftRequest,
                    2: RequestValidationTypes.tcohV2EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tcohV1EditFinalRequest,
                    2: RequestValidationTypes.tcohV2EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TOO]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tooV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tooV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tooV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tooV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TOC]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tocV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tocV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tocV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tocV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TOV]: {
        [ServiceType.referral]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tovV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tovV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tovV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tovV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.TFC]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.tfcV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tfcV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.tfcV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.tfcV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.GTC]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.gtcV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.gtcV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.gtcV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.gtcV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.DermaC]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.dermaCV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaCV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.dermaCV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaCV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.DermaSnelC]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.dermaSnelCV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaSnelCV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.dermaSnelCV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaSnelCV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.DermaCsc]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.dermaCscV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaCscV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.dermaCscV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaCscV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.DermaSnelCsc]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.dermaSnelCscV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaSnelCscV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.dermaSnelCscV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaSnelCscV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.DermaCwond]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.dermaCwondV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaCwondV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.dermaCwondV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaCwondV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.DermaOth]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.dermaOthV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaOthV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.dermaOthV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.dermaOthV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OSASEND]: {
        [ServiceType.contact]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osasendV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasendV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osasendV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasendV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OSASE]: {
        [ServiceType.contact]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osaseV1AddDraftRequest,
                    2: RequestValidationTypes.osaseV2AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osaseV1AddFinalRequest,
                    2: RequestValidationTypes.osaseV2AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osaseV1EditDraftRequest,
                    2: RequestValidationTypes.osaseV2EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osaseV1EditFinalRequest,
                    2: RequestValidationTypes.osaseV2EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OSASN]: {
        [ServiceType.contact]: {
            add: {
                draft: {
                    1: RequestValidationTypes.osasnV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasnV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.osasnV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.osasnV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OrthO]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.orthOV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.orthOV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.orthOV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.orthOV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OrthOFol]: {
        [ServiceType.examination]: {
            add: {
                draft: {
                    1: RequestValidationTypes.orthOFolV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.orthOFolV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.orthOFolV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.orthOFolV1EditFinalRequest,
                },
            },
        },
    },
    [ServiceCode.OrthC]: {
        [ServiceType.consultation]: {
            add: {
                draft: {
                    1: RequestValidationTypes.orthCV1AddDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.orthCV1AddFinalRequest,
                },
            },
            edit: {
                draft: {
                    1: RequestValidationTypes.orthCV1EditDraftRequest,
                },
                final: {
                    1: RequestValidationTypes.orthCV1EditFinalRequest,
                },
            },
        },
    },
};

export function getRequestValidationType(
    serviceCode: ServiceCode,
    serviceType: ServiceType,
    version: number,
    addOrEdit: 'add' | 'edit',
    draftOrFinal: 'draft' | 'final'
) {
    return get(requestValidationTypes, [serviceCode, serviceType, addOrEdit, draftOrFinal, version]);
}
